<template>
  <div class="friends main-top-border">
    <div class="main-wrap">
      <!--<div class="fl type-list">
        <div class="bor-bot">
          <h3 class="type-title">精选兰友圈专题</h3>
          <h4 class="type-sub">专题分类 <span class="line"></span></h4>
          <p class="sub-title"><i class="el-icon-document-copy"></i>事务处</p>
          <p class="sub-item">公告栏</p>
          <p class="sub-item">名人名兰app</p>
          <p class="sub-item">申请成为卖家</p>
        </div>
        <div class="bor-bot">
          <p class="sub-title"><i class="el-icon-document-copy"></i>鉴赏区</p>
          <ul class="lan-list">
            <li>春兰篇</li>
            <li>莲瓣篇</li>
            <li>寒兰篇</li>
            <li>送春篇</li>
            <li>蕙兰篇</li>
            <li>豆瓣篇</li>
            <li>建兰篇</li>
            <li>叶艺篇</li>
            <li>墨兰篇</li>
            <li>秋榜篇</li>
            <li>春剑篇</li>
            <li>植料篇</li>
          </ul>
        </div>
        <div class="bor-bot">
          <p class="sub-title"><i class="el-icon-document-copy"></i>议种养</p>
          <p class="sub-item">新手养兰</p>
          <p class="sub-item">种养心得</p>
          <p class="sub-item">养兰环境</p>
          <p class="sub-item">养兰环境</p>
        </div>
        <div class="bor-bot">
          <p class="sub-title"><i class="el-icon-document-copy"></i>交兰友</p>
          <p class="sub-item">新手养兰</p>
          <p class="sub-item">种养心得</p>
          <p class="sub-item">养兰环境</p>
          <p class="sub-item">养兰环境</p>
        </div>
        <button type="button" class="btn-all">查看全部</button>
    </div>-->
      <el-table
              class="shop-tab-list"
              :data="dynamicList"
              @cell-click="goTrackDetail"
              :header-row-style="{'background-color':'#EBF3EE','border':'1px solid #E0E0E0'}"
              :header-cell-style="{
                  'background-color':'#EBF3EE',
                  'font-size':'14px',
                  'color':'#333333',
                  'height':'40px',
                  'padding':'0px',
                  'text-align':'center',
                  'font-weight':'500'
              }"
      >
        <el-table-column
                label="主题"
                width="300"
                align="center"
                class-name="cell-blue"
        >
          <template slot-scope="prop">
            <div v-text="$common.interceptStr(prop.row.content,10)"></div>
<!--
            <div @click="$router.push({'path':`/celebrity/track/${prop.row.id}`})">{{prop.row.title}}</div>
-->
          </template>
        </el-table-column>
        <!--<el-table-column
                prop="shop"
                label="专题"
                width="180"
                class-name="cell-blue"
                align="center">
        </el-table-column>-->
        <el-table-column
                label="评论/赞"
                align="center">
          <template slot-scope="prop">
              {{prop.row.countReply}}/{{prop.row.goodNum}}
          </template>
        </el-table-column>
        <el-table-column
                prop="user.nickName"
                label="发表"
                class-name="cell-blue"
                align="center"
        >
        </el-table-column>
        <el-table-column
                prop="createTime"
                label="发表时间"
                align="center">
        </el-table-column>
      </el-table>
      <el-pagination
              @current-change="handleCurrentChange"
              :current-page="current"
              layout=" prev, pager, next,total, jumper"
              style="text-align: center;padding:20px;"
              :hide-on-single-page="isOnePage"
              :total="totalPage">
      </el-pagination>
    </div>
  </div>
</template>
<script>
    import {dynamicPage} from '../../api/dynamic'
  export default {
      data(){
          return {
              current:1,
              size:10,
              totalPage:0,
              dynamicList:[],
              isOnePage:false,//是否只有一页
          }
      },
      components:{
      },
      computed:{
          userId(){
              const userInfo = JSON.parse(localStorage.getItem('user'))||null;//登录用户信息
              let id=0;
              userInfo?id=userInfo.userId:id=0;
              return id;
          }
      },
      created () {
          this.getDynamicPageList();
      },
      methods:{
          goTrackDetail(row, column, cell, event){
              this.$router.push({'path':`/celebrity/track/${row.id}`})
          },
          handleCurrentChange(current){
              this.current=current;
              this.getDynamicPageList();
          },
          getDynamicPageList(){
              dynamicPage({
                  current:this.current,
                  size:this.size,
                  userId:this.userId,
              }).then(res=>{
                  this.totalPage=res.data.total;
                  this.totalPage<=this.size?this.isOnePage=true:this.isOnePage=false;
                  this.dynamicList=res.data.records
              }).catch(err=>{
                  console.log('celebrityInfo',err);
              })
          }
      }
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/css/common';
  .friends{
    padding-top:22px;
    .main-wrap{
      overflow: hidden;
    }
    .type-list{
      width:168px;
      border:1px solid #e0e0e0;
      background-color:#F6F7FB;
      font-size:14px;
      color:#666666;
      line-height:36px;
      .bor-bot{
        padding:10px 0 10px 20px;
        border-bottom:1px solid #FFFFFF;
      }
      .type-title{
        padding:0 0 19px;
      }
      .type-sub{
        color: #333333;
        padding-bottom:10px;
        .line{
          display: inline-block;
          width:80px;
          height:1px;
          background-color:#E0E0E0;
          vertical-align: middle;
        }
      }
      .sub-title{
        font-size:18px;
        color:#666666;
        font-weight:600;
        line-height:36px;
        padding-top:10px;
        i{
          padding-right:5px;
          color:$main-color;
        }
      }
      .sub-item{
        line-height:36px;
      }
      .lan-list{
        overflow: hidden;

        li{
          width:50%;
          float: left;
        }
      }
    }
    .btn-all{
      width:108px;
      height:34px;
      line-height:34px;
      border:1px solid #CBCBCB;
      background-color: #F7F7F7;
      font-size:16px;
      color:#333333;
      -webkit-border-radius: 3px;
      -moz-border-radius: 3px;
      border-radius: 3px;
      margin-left:30px;
      margin-bottom:50px;
    }
  }
</style>
<style lang="scss">
  .shop-tab-list{
    /*width:1000px;*/
    position: relative;
    background-color:#ffffff;
  }
  .cell-blue{
    color:#1457D1;
  }
</style>
